import { Fragment } from "react";
import { TbCoins } from "react-icons/tb";

import { formatUnits } from "viem";

import { ValidatorBasicInfo } from "entities/validator";
import { Validator } from "shared/api/cosmos/use-validators-query";
import { Button } from "shared/ui/button";
import { formatCurrency } from "shared/web3/utils";

import { Cell } from "./cell";

type Props = {
  disabled?: boolean;
  hasDelegation: boolean;
  index: number;
  onDelegate: () => void;
  validator: Validator;
};

export const Row = (props: Props) => {
  const { validator, index, hasDelegation, onDelegate } = props;

  const formattedShares = validator.delegator_shares
    ? formatCurrency(
        formatUnits(BigInt(parseInt(validator.delegator_shares)), 18)
      )
    : "0";

  const formattedCommission =
    parseFloat(validator.commission?.commission_rates?.rate ?? "0") * 100;
  return (
    <Fragment>
      <Cell className="px-0">{index}</Cell>
      <Cell className="justify-start">
        <ValidatorBasicInfo
          description={validator.description?.website}
          imageUrl={""}
          imgBadge={
            hasDelegation ? <TbCoins className="text-parisGreen" /> : undefined
          }
          link={validator.description?.website}
          name={validator.description?.moniker || "unknown"}
        />
      </Cell>
      <Cell>{formattedShares} GNET</Cell>
      <Cell>{formattedShares} GNET</Cell>
      <Cell>{formattedCommission} %</Cell>
      <Cell>
        <Button onClick={onDelegate}>Delegate</Button>
      </Cell>
    </Fragment>
  );
};
